import { render, staticRenderFns } from "./CatPicture.vue?vue&type=template&id=27971a88&scoped=true&"
import script from "./CatPicture.vue?vue&type=script&lang=js&"
export * from "./CatPicture.vue?vue&type=script&lang=js&"
import style0 from "./CatPicture.vue?vue&type=style&index=0&id=27971a88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27971a88",
  null
  
)

export default component.exports